import { render, staticRenderFns } from "./emp_panel.vue?vue&type=template&id=65fd4f89&scoped=true&"
import script from "./emp_panel.vue?vue&type=script&lang=js&"
export * from "./emp_panel.vue?vue&type=script&lang=js&"
import style0 from "./emp_panel.vue?vue&type=style&index=0&id=65fd4f89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd4f89",
  null
  
)

export default component.exports